import { render, staticRenderFns } from "./administer.vue?vue&type=template&id=049d7cfb&scoped=true&"
import script from "./administer.vue?vue&type=script&lang=js&"
export * from "./administer.vue?vue&type=script&lang=js&"
import style0 from "./administer.vue?vue&type=style&index=0&id=049d7cfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d7cfb",
  null
  
)

export default component.exports